import { render, staticRenderFns } from "./Jobiq.vue?vue&type=template&id=4aa78d2e&scoped=true"
import script from "./Jobiq.vue?vue&type=script&lang=js"
export * from "./Jobiq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa78d2e",
  null
  
)

export default component.exports